import axios from 'axios';

export const editForm = async (e) => {
  const { data } = await axios.post('/PgSection/EditSectionFrom', e);
  return data;
};
